import * as z from 'zod';

import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { teamMemberQueryLinkerSchema } from './team-members-query-linker-schema';

export const teamMemberQueryLinkerWithContactInfoSchema = teamMemberQueryLinkerSchema.extend({
  phone_numbers: z.array(phoneNumberQuerySchema).nullish(),
});

export type TeamMemberQueryLinkerWithContactInfoSchema = z.infer<typeof teamMemberQueryLinkerWithContactInfoSchema>;
